import React from 'react'
import BranchList from '../branch_components/branch_list'

export default function Main() {
  return <BranchList />
}
